import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-studies-detail',
  templateUrl: './studies-detail.component.html',
  styleUrls: ['./studies-detail.component.sass']
})
export class StudiesDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
